export const PREFIX_STR = '[AutoTable]';

export const log = {
  error: (...rest: any) => {
    console.error(PREFIX_STR, ...rest);
  },
  info: (...rest: any) => {
    console.log(PREFIX_STR, ...rest);
  },
  warn: (...rest: any) => {
    console.warn(PREFIX_STR, ...rest);
  },
};
